import XLSX from "xlsx";

export const export_xlsx = ({ data, fileName, sheetList} = {}) => {
  let workbook = XLSX.utils.book_new();
  console.log(data)
  if(sheetList && sheetList.length>0){
    sheetList.map((item,i)=>{
      let sheet = XLSX.utils.aoa_to_sheet(data[i]);
      XLSX.utils.book_append_sheet(workbook, sheet, item);
    })
  }else{
    let sheet = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, sheet);
  }
  XLSX.writeFile(workbook, fileName + ".xlsx"); 
};
